// ==============================|| SIDEBAR - DARK PALETTE ||============================== //

// The drawer is intentionally dark whatever the app theme is, so the brand mark
// and the gold accent read the same way they do on localbalivillas.com.
// Everything drawer related pulls its colours from here so the dark surface
// stays consistent between the permanent and the temporary (mobile) drawer.
const sidebarColors = {
  background: '#0D0D0F',
  surface: '#17171B',
  border: 'rgba(255, 255, 255, 0.08)',
  text: 'rgba(255, 255, 255, 0.68)',
  textActive: '#FFFFFF',
  textMuted: 'rgba(255, 255, 255, 0.38)',
  accent: '#C9A76B',
  accentSoft: 'rgba(201, 167, 107, 0.14)',
  hover: 'rgba(255, 255, 255, 0.06)'
};

export default sidebarColors;
